export { DatabaseAlt as default } from './DatabaseAlt';
